import SectionSummary from './SectionSummary';

export default SectionSummary;
